class VideoBlock {
    constructor() {
    }

    init() {
        this.changeMobileView();
        this.videoStartFallbackByTouchStartEvent();

        window.addEventListener("resize", () => {
            this.changeMobileView();
        });

        screen.orientation.addEventListener("change", () => {
            this.changeMobileView();
        });
    }

    changeMobileView() {
        const videoColl = document.querySelectorAll('[data-mobile-placeholder]');

        if (videoColl.length > 0) {
            videoColl.forEach(function (video) {
                const placeholder = video.dataset.mobilePlaceholder;
                const mobilePlaceholderElement = document.querySelector("." + placeholder);
                const origPlaceholderElement = document.querySelector("." + placeholder + "-orig");

                if (window.innerWidth <= 768) {
                    if (!VideoBlock.checkNextElementDataSet(mobilePlaceholderElement, placeholder)) {
                        video.classList.add('mt-2', 'mb-4');
                        mobilePlaceholderElement.after(video);
                    }
                } else {
                    if (!VideoBlock.checkNextElementDataSet(origPlaceholderElement, placeholder)) {
                        video.classList.remove('mt-2', 'mb-4');
                        origPlaceholderElement.after(video);
                    }
                }
            });
        }
    }

    static checkNextElementDataSet = (element, dataSetValue) => {
        if (typeof element !== "undefined") {
            const el = element.nextSibling;

            if (typeof el.dataset !== "undefined" && "mobilePlaceholder" in el.dataset) {
                if (el.dataset.mobilePlaceholder === dataSetValue) {
                    return true;
                }
            }
        }

        return false;
    }

    videoStartFallbackByTouchStartEvent() {
        const videoColl = document.querySelectorAll('.pimcore_video');

        videoColl.forEach(function (video) {
            video.addEventListener('touchstart', function () {
                setTimeout(function() {
                    if (video.paused) {
                        video.play();
                    } else {
                        video.pause();
                    }
                }, 300);

            });
        });
    }
}

export default new VideoBlock();